<template>
  <div
    class="flex m-1 grow mr-0 flex-col relative rounded border-2 border-primary bg-white overflow-y-auto scrollbar-hide"
    :class="{ 'w-[280px] max-w-[280px]': !compactMode }"
  >
    <div class="shadow sticky top-0 bg-white">
      <SettingsMenu/>
      <SidebarSearch v-if="!compactMode"/>
    </div>
    <div class="flex flex-col grow shrink p-2">
      <SidebarParentItem
        v-for="item in filteredItems"
        v-bind="{ item }"
        :key="item.id"
      />
    </div>
    <div class="sticky bottom-0 bg-white pb-2">
    <SidebarControls class="mx-2 mt-2"/>
		<BridgeStatusIndicator :compact-mode="compactMode" class="mx-2 mt-1" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { useAppSidebarStore } from "~/stores/AppSidebar";

const { filteredItems, compactMode } = storeToRefs(useAppSidebarStore());
</script>
